import { Box, Tooltip } from "@mui/material";
import type { PropsWithChildren } from "react";

interface Props {
  title?: string;
  isActionDisabled?: boolean;
}

// A disabled MUI button swallows pointer and focus events, so the tooltip needs a wrapper to hang off.
const TooltipForDisabledAction = ({ title, isActionDisabled, children }: PropsWithChildren<Props>) => {
  if (!title) {
    return <>{children}</>;
  }

  return (
    <Tooltip title={title} arrow describeChild>
      <Box component="span" tabIndex={isActionDisabled ? 0 : undefined} sx={{ display: "inline-grid" }}>
        {children}
      </Box>
    </Tooltip>
  );
};

export default TooltipForDisabledAction;
